var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLeftTool2Active(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2522 13.3357C18.714 13.0752 19.2996 13.0752 19.7615 13.3357L36.1054 22.5537C36.9871 23.0509 37.0029 24.2065 36.135 24.7233L19.7911 34.4556C19.3152 34.7389 18.6984 34.7389 18.2226 34.4556L1.87865 24.7233C1.01079 24.2065 1.02656 23.0509 1.90826 22.5537L18.2522 13.3357Z",
    fill: "#E5F0E3",
    stroke: "#247499",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82867 27.1133L24.6424 16.0181M12.2924 30.764L31.2526 19.8121",
    stroke: "#247499",
    strokeWidth: 1.26636
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2696 27.1133L13.4559 16.0181M26.0645 30.764L7.35414 19.5774",
    stroke: "#247499",
    strokeWidth: 1.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0485 2.11621C14.8817 2.11621 11.5 5.54158 11.5 9.76146C11.5 11.1781 11.7265 11.9501 12.1039 13.1568C13.2211 16.7471 18.5805 21.5441 19.0485 22.0613C19.5165 21.5441 24.8683 16.7471 25.9855 13.1793C26.3629 11.9651 26.5969 11.1931 26.5969 9.76895C26.5969 5.54908 23.2152 2.12371 19.0485 2.12371V2.11621ZM19.0485 13.1119C16.9651 13.1119 15.2742 11.4329 15.2742 9.3642C15.2742 7.29549 16.9651 5.61653 19.0485 5.61653C21.1319 5.61653 22.8227 7.29549 22.8227 9.3642C22.8227 11.4329 21.1319 13.1119 19.0485 13.1119Z",
    fill: "white",
    stroke: "#247499",
    strokeWidth: 1.6875,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLeftTool2Active);
export default __webpack_public_path__ + "static/media/ico-left-tool-2-active.ca66b27a9f6d7d9d2ea39f1ed0feb953.svg";
export { ForwardRef as ReactComponent };